import React from 'react'

import { Section, SectionHeading, Button } from '../../../components/ui'
import { whatsappChatProps } from '../../../components/whatsapp-chat'
import { bookingPath, defaultWashSlug, enterBooking } from '../../../lib/booking-entry'

import './ask-cta.css'

// THE FOOT OF THE PAGE. Two jobs, so two <Section>s and two H2s, which is
// the same arrangement sections/areas-cta uses at the foot of the home page:
// a way to ask, then the one thing the page asks for.
//
// THE ASK BAND EXISTS BECAUSE THIS PAGE WILL ALWAYS BE INCOMPLETE. Seventeen
// answers do not cover a van with a height restriction, a fleet of four, or
// a car that has been standing under a lime tree since June, and the old page
// handled all of that by telling people to "contact your Operator", which has
// been impossible since assignment went internal on 2026-09-29 (the customer
// is never told who took the job). So the routes out are the two the rest of
// the site uses: WhatsApp through whatsappChatProps, which keeps the wa.me
// href on a phone and opens the number form on a desktop (docs/WHATSAPP.md),
// and support@gowashmycar.com, which the footer already publishes and which
// lands in the same Chatwoot inbox.
//
// NO PHONE NUMBER HERE, and no call anywhere on the site (Robin, 26 Oct
// 2026: "whatsapp and chat and email enough imo"). The footer prints the
// number once, as its WhatsApp link's label, because a number published in
// several places went stale once already. One contact route per block rather
// than two of each.
//
// THE CTA IS THE PAGE'S ONE FILLED BUTTON (DESIGN.md §3), centred, and the
// same object as the closing CTA on the home page and on /services, down to
// the full-width button on a phone and the auto-width one above 960px, so
// every page ends the same way.
//
// AND IT QUOTES NO PRICE, which is where it differs from those two. The
// prices on this page are a link to /services and nothing else: the catalogue
// has changed twice in a fortnight, a number typed into the bundle goes stale
// without anyone noticing, and a page whose whole job is to be believed is
// the worst place on the site to carry a stale figure. The one fact under
// the button is the card on file, which is true whatever the catalogue does
// and is the same line §7.7 closes the home page with: both closing CTAs are
// the same object, down to this caption. It said "Nothing is charged until a
// washer accepts your booking" until 5 Oct, which put our dispatch mechanics
// under a Book button and made a confirmed booking read as a maybe.

export const AskAndCta = () => (
  <>
    <Section background="stone" className="faq-ask">
      <SectionHeading intro="Message us on WhatsApp and one of us will get back to you.">
        Still got a question?
      </SectionHeading>

      <div className="faq-ask-routes">
        <a
          className="gwmc-link faq-ask-link"
          {...whatsappChatProps('Hi GoWashMyCar! I have a question about a wash')}>
          Ask us on WhatsApp
        </a>
        <a className="gwmc-link faq-ask-link" href="mailto:support@gowashmycar.com">
          Email support@gowashmycar.com
        </a>
      </div>
    </Section>

    <Section centred className="faq-cta">
      <SectionHeading intro="A professional valeter comes to you, wherever the car is parked.">
        Ready for a spotless car?
      </SectionHeading>

      <Button
        className="faq-cta-btn"
        variant="primary"
        href={bookingPath(defaultWashSlug())}
        onClick={event => {
          event.preventDefault()
          enterBooking(defaultWashSlug(), 'faqs_final_cta')
        }}>
        Book now
      </Button>

      <p className="gwmc-caption faq-cta-note">We keep your card on file to make repeat bookings easy.</p>
    </Section>
  </>
)
